"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selector = void 0;
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var Context_1 = require("./Context");
var remote_1 = require("./../../remote");
var common_1 = require("./../common");
var ChooseArtwork_1 = __importDefault(require("./Artwork/ChooseArtwork"));
var EditArtwork_1 = __importDefault(require("./Artwork/EditArtwork"));
var Frame_1 = __importDefault(require("./Frame"));
var SaveProductModal_1 = __importDefault(require("./SaveProductModal"));
var SuccessProductModal_1 = __importDefault(require("./SuccessProductModal"));
var AddProductCartModal_1 = __importDefault(require("./AddProductCartModal"));
var Quantity_1 = __importDefault(require("./Quantity"));
var CoaModal_1 = require("../common/CoaModal");
var isBrowser = function () { return typeof window !== "undefined"; };
exports.Selector = function (props) {
    var _a, _b, _c;
    var _d = window.__initialState, _e = _d.page, _f = _e.product, product = _f === void 0 ? {} : _f, _g = _e.category, category = _g === void 0 ? {} : _g, _h = _d.tenant, tenant = _h === void 0 ? {} : _h;
    var context = react_1.useContext(Context_1.ProductContext);
    var quantity = context.quantity, selectedProduct = context.selectedProduct, selectedArtwork = context.selectedArtwork, isLoading = context.isLoading, refHandleExport = context.refHandleExport, saveArtworkDetail = context.saveArtworkDetail, 
    // hasResolutionWarning,
    setArtworkPanel = context.setArtworkPanel, coaFields = context.coaFields, setCoaFields = context.setCoaFields;
    var _j = react_1.useState(false), wasPreviewed = _j[0], setWasPreviewed = _j[1];
    var _k = react_1.useState(false), showReminder = _k[0], setShowReminder = _k[1];
    var _l = react_1.useState(false), save = _l[0], setSave = _l[1];
    var _m = react_1.useState(false), isSubmitting = _m[0], setIsSubmitting = _m[1];
    var _o = react_1.useState({
        saveProduct: false,
        editArtwork: false,
        successProduct: false,
        addProductToCart: false,
        newProduct: false,
        warning: false,
        coa: false
    }), isOpenModal = _o[0], setIsOpenModal = _o[1];
    // const [coaFields, setCoaFields] = useState([]);
    var _p = react_1.useState(null), cart = _p[0], setCart = _p[1];
    var _q = react_1.useState([]), categories = _q[0], setCategories = _q[1];
    var _r = react_1.useState({
        addToCart: false
    }), isDone = _r[0], setIsDone = _r[1];
    var loadCategory = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, remote_1.getCategories()];
                case 1:
                    res = _b.sent();
                    setCategories((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var loadCart = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, remote_1.getCart()];
                case 1:
                    res = _a.sent();
                    // console.log("loadCart", res);
                    setCart(res === null || res === void 0 ? void 0 : res.data);
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        loadCart();
    }, []);
    react_1.useEffect(function () {
        if (isOpenModal.newProduct) {
            loadCategory();
        }
    }, [isOpenModal.newProduct]);
    if ((window === null || window === void 0 ? void 0 : window.gtag) !== undefined) {
        window === null || window === void 0 ? void 0 : window.gtag("event", "view_item", {
            currency: tenant.currency,
            value: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price,
            items: [
                {
                    item_id: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.key,
                    item_name: (_a = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.staticName) !== null && _a !== void 0 ? _a : "",
                    item_category: category === null || category === void 0 ? void 0 : category.name,
                    price: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price
                }
            ]
        });
    }
    var handleAddCOA = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            e.preventDefault();
            setIsOpenModal(__assign(__assign({}, isOpenModal), { coa: true }));
            return [2 /*return*/];
        });
    }); };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var artworkUploadImage, artworkThumbUploadImage, artworkBlob, artworkThumbBlob, resAll, artwork, thumb, _learnq, items, res, e_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        return __generator(this, function (_3) {
            switch (_3.label) {
                case 0:
                    setIsSubmitting(true);
                    setIsDone(__assign(__assign({}, isDone), { addToCart: false }));
                    if ((window === null || window === void 0 ? void 0 : window.gtag) !== undefined) {
                        window === null || window === void 0 ? void 0 : window.gtag("event", "add_to_cart", {
                            currency: tenant.currency,
                            value: selectedProduct.price,
                            items: [
                                {
                                    item_id: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.key,
                                    item_name: (_a = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.staticName) !== null && _a !== void 0 ? _a : "",
                                    item_category: category === null || category === void 0 ? void 0 : category.name,
                                    price: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price
                                }
                            ]
                        });
                    }
                    _3.label = 1;
                case 1:
                    _3.trys.push([1, 7, , 8]);
                    artworkUploadImage = saveArtworkDetail === null || saveArtworkDetail === void 0 ? void 0 : saveArtworkDetail.artwork, artworkThumbUploadImage = saveArtworkDetail === null || saveArtworkDetail === void 0 ? void 0 : saveArtworkDetail.thumb;
                    if (!!(saveArtworkDetail === null || saveArtworkDetail === void 0 ? void 0 : saveArtworkDetail.artwork)) return [3 /*break*/, 5];
                    return [4 /*yield*/, ((_b = refHandleExport === null || refHandleExport === void 0 ? void 0 : refHandleExport.current) === null || _b === void 0 ? void 0 : _b.export())];
                case 2:
                    artworkBlob = _3.sent();
                    return [4 /*yield*/, ((_c = refHandleExport === null || refHandleExport === void 0 ? void 0 : refHandleExport.current) === null || _c === void 0 ? void 0 : _c.export("thumb"))];
                case 3:
                    artworkThumbBlob = _3.sent();
                    return [4 /*yield*/, Promise.all((_d = [artworkBlob, artworkThumbBlob]) === null || _d === void 0 ? void 0 : _d.map(function (a) { return remote_1.uploadImage(a); }))];
                case 4:
                    resAll = _3.sent();
                    artwork = (_k = (_j = (_h = (_g = (_f = (_e = resAll[0]) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.response) === null || _g === void 0 ? void 0 : _g.files) === null || _h === void 0 ? void 0 : _h.files) === null || _j === void 0 ? void 0 : _j[0]) !== null && _k !== void 0 ? _k : (_p = (_o = (_m = (_l = resAll[0]) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.files) === null || _o === void 0 ? void 0 : _o.files) === null || _p === void 0 ? void 0 : _p[0];
                    thumb = (_u = (_t = (_s = (_r = (_q = resAll[1]) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.files) === null || _s === void 0 ? void 0 : _s.files) === null || _t === void 0 ? void 0 : _t[0]) !== null && _u !== void 0 ? _u : (_z = (_y = (_x = (_w = (_v = resAll[1]) === null || _v === void 0 ? void 0 : _v.data) === null || _w === void 0 ? void 0 : _w.response) === null || _x === void 0 ? void 0 : _x.files) === null || _y === void 0 ? void 0 : _y.files) === null || _z === void 0 ? void 0 : _z[0];
                    artworkUploadImage = artwork;
                    artworkThumbUploadImage = thumb;
                    _3.label = 5;
                case 5:
                    _learnq = window._learnq || [];
                    items = ((_0 = cart === null || cart === void 0 ? void 0 : cart.items) === null || _0 === void 0 ? void 0 : _0.map(function (item) {
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        return ({
                            ProductID: (_a = item === null || item === void 0 ? void 0 : item.product) === null || _a === void 0 ? void 0 : _a._id,
                            SKU: (_b = item === null || item === void 0 ? void 0 : item.product) === null || _b === void 0 ? void 0 : _b.key,
                            ProductName: (_d = (_c = item === null || item === void 0 ? void 0 : item.product) === null || _c === void 0 ? void 0 : _c.staticName) !== null && _d !== void 0 ? _d : "",
                            Quantity: item === null || item === void 0 ? void 0 : item.quantity,
                            ItemPrice: (((_e = item === null || item === void 0 ? void 0 : item.product) === null || _e === void 0 ? void 0 : _e.price) / (item === null || item === void 0 ? void 0 : item.quantity)).toFixed(2),
                            RowTotal: (_g = (_f = item === null || item === void 0 ? void 0 : item.product) === null || _f === void 0 ? void 0 : _f.price) === null || _g === void 0 ? void 0 : _g.toFixed(2),
                            ProductCategories: [(_h = item === null || item === void 0 ? void 0 : item.category) === null || _h === void 0 ? void 0 : _h.hrCode]
                        });
                    })) || [];
                    _learnq.push([
                        "track",
                        "Added to Cart",
                        {
                            $value: (cart === null || cart === void 0 ? void 0 : cart.subtotal) + (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price),
                            AddedItemProductID: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct._id,
                            AddedItemSKU: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.key,
                            AddedItemCategories: [category === null || category === void 0 ? void 0 : category.hrCode],
                            AddedItemURL: window.location.href,
                            AddedItemPrice: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price,
                            AddedItemQuantity: quantity,
                            ItemNames: __spreadArrays(((items === null || items === void 0 ? void 0 : items.map(function (item) { return item === null || item === void 0 ? void 0 : item.ProductName; })) || []), [""]),
                            Items: __spreadArrays((items || []), [
                                {
                                    ProductID: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct._id,
                                    SKU: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.key,
                                    Quantity: quantity,
                                    ItemPrice: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price) / quantity,
                                    RowTotal: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price,
                                    ProductCategories: [category === null || category === void 0 ? void 0 : category.hrCode]
                                }
                            ])
                        }
                    ]);
                    return [4 /*yield*/, remote_1.addToCart({
                            product: selectedProduct,
                            quantity: quantity,
                            // artworkSlotsWithUrls: [{
                            //   sequence: 'MULTIPAGEPDF',
                            //   url: `https://storage.googleapis.com/icstorage/${selectedArtwork?.artwork?.cloudFilename}`
                            // }],
                            images: [
                                {
                                    url: (_2 = (_1 = artworkThumbUploadImage === null || artworkThumbUploadImage === void 0 ? void 0 : artworkThumbUploadImage.thumbnails) === null || _1 === void 0 ? void 0 : _1[0]) === null || _2 === void 0 ? void 0 : _2.url
                                }
                            ],
                            artworkSlotsWithUrls: [
                                {
                                    sequence: "MULTIPAGEPDF",
                                    url: "https://storage.googleapis.com/icstorage/" + artworkUploadImage.cloudFilename
                                }
                            ]
                        })];
                case 6:
                    res = _3.sent();
                    // window.location.href = '/cart'
                    setIsOpenModal(__assign(__assign({}, isOpenModal), { saveProduct: false, successProduct: false, addProductToCart: true }));
                    if (res.data.result !== undefined && res.data.result === false) {
                        ICWidgets.Client.emit("cart-item-error", {
                            message: res.data.errorMessage || res.data.message
                        });
                        // setErrorMessage(res.data.errorMessage || res.data.message)
                    }
                    else {
                        ICWidgets.Client.emit("cart-item-added", {
                            count: res.data.items.length
                        });
                        setIsDone(__assign(__assign({}, isDone), { addToCart: true }));
                    }
                    return [3 /*break*/, 8];
                case 7:
                    e_1 = _3.sent();
                    console.log("e", e_1);
                    return [3 /*break*/, 8];
                case 8:
                    setIsSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var isBtnDisabled = !(selectedArtwork === null || selectedArtwork === void 0 ? void 0 : selectedArtwork.artwork);
    var productPrice = (_b = (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price) * quantity) !== null && _b !== void 0 ? _b : 0;
    var coaFeature = false;
    if (isBrowser() && ((_c = location === null || location === void 0 ? void 0 : location.search) === null || _c === void 0 ? void 0 : _c.includes("coa"))) {
        coaFeature = true;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "ic-product-widget-selector py-3 py-md-5" },
            react_1.default.createElement("div", { className: "px-3 px-lg-4" },
                (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.isOutOfStockManual) && (react_1.default.createElement("div", { className: "alert alert-danger" }, "Product is out of stock")),
                react_1.default.createElement("h2", { className: "h2 text-center" }, "Customise Your Frame"),
                react_1.default.createElement("div", { className: "py-3 px-md-5" },
                    react_1.default.createElement("h4", { className: "mb-3 mb-md-4 title-numbering", "data-number": "1" }, "Choose Your Artwork"),
                    react_1.default.createElement(ChooseArtwork_1.default, { onChange: setWasPreviewed, isDisabled: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.isOutOfStockManual })),
                react_1.default.createElement("hr", null),
                isLoading ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                        react_1.default.createElement("div", { className: "spinner-border", role: "status" },
                            react_1.default.createElement("span", { className: "sr-only" }, "Loading..."))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "py-3 px-md-5" },
                        react_1.default.createElement("h4", { className: "mb-3 mb-md-4 title-numbering", "data-number": "2" }, "Customise Your Frame"),
                        react_1.default.createElement(Frame_1.default, { isDisabled: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.isOutOfStockManual })),
                    react_1.default.createElement("hr", null))),
                react_1.default.createElement("div", { className: "px-md-5 py-3" },
                    react_1.default.createElement("h4", { className: "mb-3 mb-md-4 title-numbering", "data-number": "3" }, "Prepare Your Print"),
                    react_1.default.createElement("div", { className: "" },
                        react_1.default.createElement("div", { className: "mb-2" },
                            react_1.default.createElement(common_1.Button, { disabled: isBtnDisabled, className: "btn btn-primary btn-block " + (showReminder ? "pulsating" : ""), style: {
                                    outline: !wasPreviewed && !isBtnDisabled
                                        ? "3px solid var(--pink)"
                                        : undefined,
                                    borderColor: !wasPreviewed && !isBtnDisabled
                                        ? "var(--pink)"
                                        : undefined
                                }, onClick: function () {
                                    setShowReminder(false);
                                    setWasPreviewed(false);
                                    setIsOpenModal(__assign(__assign({}, isOpenModal), { editArtwork: true }));
                                    setArtworkPanel("scale");
                                }, content: "Check Artwork Position" })),
                        react_1.default.createElement("div", { className: "" },
                            react_1.default.createElement(common_1.Button, { disabled: isBtnDisabled, className: "btn btn-primary btn-block", onClick: function () {
                                    setWasPreviewed(false);
                                    setIsOpenModal(__assign(__assign({}, isOpenModal), { editArtwork: true }));
                                    setArtworkPanel("signature");
                                }, content: "SIGN MY ART" })))),
                react_1.default.createElement("hr", null),
                react_1.default.createElement("div", { className: "px-md-5 py-3" },
                    react_1.default.createElement("h4", { className: "mb-3 mb-md-4 title-numbering", "data-number": "4" }, "Quantity"),
                    react_1.default.createElement("div", { className: "form-group" },
                        react_1.default.createElement(Quantity_1.default, { isDisabled: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.isOutOfStockManual })))),
            selectedProduct && coaFeature && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("hr", null),
                react_1.default.createElement("div", { className: "px-md-5 py-3" },
                    react_1.default.createElement("h4", { className: "mb-3 mb-md-4 title-numbering", "data-number": "5" }, "Certificate of Authenticity"),
                    react_1.default.createElement("div", { className: "form-group" },
                        react_1.default.createElement("div", { className: "form-check" },
                            react_1.default.createElement("input", { className: "form-check-input", type: "radio", name: "coa", id: "noCoa", checked: !(coaFields === null || coaFields === void 0 ? void 0 : coaFields.enabled), onChange: function () {
                                    return setCoaFields(__assign(__assign({}, coaFields), { enabled: false }));
                                } }),
                            react_1.default.createElement("label", { className: "form-check-label", htmlFor: "noCoa" }, "No certificate of Authenticity")),
                        react_1.default.createElement("div", { className: "form-check" },
                            react_1.default.createElement("input", { className: "form-check-input", type: "radio", name: "coa", id: "withCoa", checked: !!(coaFields === null || coaFields === void 0 ? void 0 : coaFields.enabled), onChange: handleAddCOA }),
                            react_1.default.createElement("label", { className: "form-check-label", htmlFor: "withCoa" }, "Certificate of Authenticity")))))),
            !!(coaFields === null || coaFields === void 0 ? void 0 : coaFields.enabled) && (react_1.default.createElement("div", { className: "bg-white" },
                react_1.default.createElement("div", { className: "p-3 p-md-5 bg-white" },
                    react_1.default.createElement("div", { className: "h3 text-center", style: { fontSize: "20px" } },
                        react_1.default.createElement("div", { style: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            } },
                            react_1.default.createElement("span", { className: "px-3", style: {
                                    textAlign: "right",
                                    flex: 1,
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center"
                                } },
                                react_1.default.createElement("span", { onClick: function () {
                                        return setCoaFields(__assign(__assign({}, coaFields), { enabled: false }));
                                    }, style: {
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "var(--pink)",
                                        color: "white",
                                        borderRadius: "50%",
                                        width: "1.25em",
                                        height: "1.25em",
                                        marginRight: "0.75em",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                        fontSize: "1em",
                                        userSelect: "none"
                                    }, title: "Remove Certificate of Authenticity", "aria-label": "Remove Certificate of Authenticity" }, "\u2212"),
                                "Certificate of Authenticity"),
                            react_1.default.createElement("span", { className: "px-3", style: { marginLeft: "auto" } },
                                react_1.default.createElement(react_intl_1.FormattedNumber, { value: 9.95, style: "currency", currency: context.currency }))))),
                react_1.default.createElement("hr", { style: { backgroundColor: "white" } }))),
            selectedProduct && (react_1.default.createElement("div", { className: "p-3 p-md-5 bg-white" },
                react_1.default.createElement("div", { className: "h3 text-center" },
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        } },
                        react_1.default.createElement("span", { style: {
                                textTransform: "uppercase",
                                textAlign: "right",
                                flex: 1,
                                display: "flex",
                                justifyContent: "flex-end"
                            }, className: "px-3" }, "Subtotal"),
                        react_1.default.createElement("span", { className: "px-3", style: { marginLeft: "auto" } },
                            react_1.default.createElement(react_intl_1.FormattedNumber, { value: productPrice, style: "currency", currency: context.currency })))))),
            react_1.default.createElement("div", { className: "p-3 p-md-5 bg-primary" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-12 col-md" }, react_1.default.createElement(common_1.Button, { disabled: isBtnDisabled || !wasPreviewed, className: "btn-block py-3", onClick: function () {
                            setIsOpenModal(__assign(__assign({}, isOpenModal), { saveProduct: true }));
                            setIsDone(__assign(__assign({}, isDone), { addToCart: false }));
                        } },
                        react_1.default.createElement("i", { className: "fas fa-star" }),
                        " SAVE PRODUCT")),
                    react_1.default.createElement("div", { className: "col-12 col-md atc-btn", onMouseEnter: function () {
                            // console .log("hover");
                            !wasPreviewed && setShowReminder(true);
                        } },
                        react_1.default.createElement(common_1.Button, { variant: "pink", className: " btn-block py-3", loading: isSubmitting, disabled: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.isOutOfStockManual) ||
                                isSubmitting ||
                                isBtnDisabled ||
                                !wasPreviewed, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var dpi;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, ((_a = refHandleExport === null || refHandleExport === void 0 ? void 0 : refHandleExport.current) === null || _a === void 0 ? void 0 : _a.checkForResolution())];
                                        case 1:
                                            dpi = _b.sent();
                                            Math.round(dpi) < 150
                                                ? setIsOpenModal(__assign(__assign({}, isOpenModal), { warning: true }))
                                                : handleSubmit();
                                            return [2 /*return*/];
                                    }
                                });
                            }); } },
                            react_1.default.createElement("i", { className: "fas fa-shopping-cart" }),
                            " ADD TO CART"),
                        showReminder && (react_1.default.createElement("div", { className: "mt-3 alert alert-danger" }, "Don\u2019t forget to check the position of your artwork!")))))),
        isOpenModal.warning && (react_1.default.createElement(common_1.ModalWrapper, { isOpen: true, onClose: function () {
                return setIsOpenModal(__assign(__assign({}, isOpenModal), { warning: false }));
            }, "aria-labelledby": "modal-label", style: { maxWidth: "450px" } },
            react_1.default.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    minHeight: "150px"
                } },
                react_1.default.createElement("div", { className: "alert alert-warning mt-3" }, "It looks like your photo resolution is too low to print."),
                react_1.default.createElement("div", { className: "text-right" },
                    react_1.default.createElement(common_1.Button, { className: "", variant: "outline-secondary", onClick: function () {
                            return setIsOpenModal(__assign(__assign({}, isOpenModal), { warning: false }));
                        } }, "Fix"),
                    react_1.default.createElement(common_1.Button, { className: "ml-3", loading: isSubmitting, disabled: isSubmitting, onClick: handleSubmit }, "Ignore and Add to Cart"))))),
        isOpenModal.saveProduct && (react_1.default.createElement(SaveProductModal_1.default, { onClose: function () {
                return setIsOpenModal(__assign(__assign({}, isOpenModal), { saveProduct: false }));
            }, onSave: function (v) {
                setSave(v);
                setIsOpenModal(__assign(__assign({}, isOpenModal), { saveProduct: false, successProduct: v }));
            } })),
        isOpenModal.successProduct && (react_1.default.createElement(SuccessProductModal_1.default, { onClose: function () {
                return setIsOpenModal(__assign(__assign({}, isOpenModal), { saveProduct: false, successProduct: false }));
            }, isDone: isDone.addToCart, isSubmitting: isSubmitting, onSubmit: handleSubmit })),
        isOpenModal.addProductToCart && (react_1.default.createElement(AddProductCartModal_1.default, { onClose: function () {
                return setIsOpenModal(__assign(__assign({}, isOpenModal), { addProductToCart: false }));
            }, onNewProduct: function () {
                return setIsOpenModal(__assign(__assign({}, isOpenModal), { newProduct: true, addProductToCart: false }));
            } })),
        isOpenModal.newProduct && (react_1.default.createElement(common_1.AddProduct, { onClose: function () {
                return setIsOpenModal(__assign(__assign({}, isOpenModal), { newProduct: false }));
            }, categories: categories })),
        isOpenModal.editArtwork && (react_1.default.createElement(EditArtwork_1.default, { onClose: function () {
                setWasPreviewed(true);
                setIsOpenModal(__assign(__assign({}, isOpenModal), { editArtwork: false }));
            } })),
        isOpenModal.coa && (react_1.default.createElement(CoaModal_1.CoaModal, { onClose: function () {
                return setIsOpenModal(__assign(__assign({}, isOpenModal), { coa: false }));
            }, categories: categories, defaultValues: {}, onSubmit: function (v) {
                console.log("got some values from it", v);
                setCoaFields(v);
                setIsOpenModal(__assign(__assign({}, isOpenModal), { coa: false }));
            } }))));
};
